import React from "react";
import styled from "styled-components";
import { Logo } from "./LogoBox";
import { FixedColumn } from "../common/Flex";
import { breakpoints } from "../../breakpoints";

const FooterContainer = styled.div`
    padding-top: var(--vertical-spacing);
    padding-bottom: var(--vertical-spacing);
    background-color: var(--jargon-primary);
    width: 100%;
    position: relative;
    overflow: hidden;
    font-size:1rem;
`;

const NoiseOverlay = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
`;

const FooterInner = styled.div`
    position: relative;
    max-width: var(--content-max-width);
    padding-left: var(--content-horizontal-padding);
    padding-right: var(--content-horizontal-padding);
    margin-left: auto;
    margin-right: auto;
    display: flex;
    gap: 3rem;

    @media (max-width: ${breakpoints.maxWidthXs}) {
        flex-direction: column;
    }
`;

const FooterLogoBox = styled(FixedColumn).attrs({width:"200px"})`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.maxWidthXs}) {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 1rem;
    }
`;

const FooterMainContent = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
    flex-grow: 1;
`;

const FooterText = styled.div`
    font-size: 18px;
    line-height: 1.6;
    margin: 0 0 1rem 0;

    a {
        color: yellow;
        text-decoration: underline;

        &:hover {
            text-decoration:none;
        }
    }
`;

const Copyright = styled.div`
    font-size: 1rem;
    margin-top: auto;
`;

export const Footer : React.FC = () => {
    const currentYear = new Date().getFullYear();

    return(
        <FooterContainer>
            <NoiseOverlay id="noice">
                <filter id="noise-filter">
                    <feTurbulence type="fractalNoise" baseFrequency="1.32" numOctaves="4" stitchTiles="stitch"></feTurbulence>
                    <feColorMatrix type="saturate" values="0"></feColorMatrix>
                    <feComponentTransfer>
                        <feFuncR type="linear" slope="0.43"></feFuncR>
                        <feFuncG type="linear" slope="0.43"></feFuncG>
                        <feFuncB type="linear" slope="0.43"></feFuncB>
                        <feFuncA type="linear" slope="0.37"></feFuncA>
                    </feComponentTransfer>
                    <feComponentTransfer>
                        <feFuncR type="linear" slope="1.41" intercept="-0.20"/>
                        <feFuncG type="linear" slope="1.41" intercept="-0.20"/>
                        <feFuncB type="linear" slope="1.41" intercept="-0.20"/>
                    </feComponentTransfer>
                </filter>
                <rect width="100%" height="100%" filter="url(#noise-filter)"></rect>
            </NoiseOverlay>
            <FooterInner>
                <FooterLogoBox>
                    <Logo src="/jargon-ipsum-linen.svg" />
                </FooterLogoBox>
                <FooterMainContent>
                    <FooterText>
                        <p><strong>Enjoying this? Is it entertaining? And useful? We're thrilled! Who are we? We're HALO 22 and we created this.</strong></p>
                        <p>We create many things for lots of clients. It's often the words that pose the biggest challenges. 
                            We're here to help. <a href="http://halo22.net/jargon-ipsum?utm_source=ji&utm_content=footer" target="_blank">
                        When you need high-quality copy for your website, annual report, brochure, or blog, check us out.</a></p>
                        <p><strong>Just appreciate a fun thing on the internet and want to support it? <a href="https://buymeacoffee.com/halo22">Buy the team a round.</a></strong></p>
                    </FooterText>
                    <Copyright>
                        © {currentYear} HALO 22
                    </Copyright>
                </FooterMainContent>
            </FooterInner>
        </FooterContainer>
    );
}